import StandingTable from './StandingTable';

export default StandingTable;
